/* Selo de disponibilidade no cart drawer.
 *
 * POR QUE E UM ASSET E NAO UM <script> DENTRO DO DRAWER
 * O cart-drawer.js da Dawn troca innerHTML de #CartDrawer (ao adicionar) e de
 * .drawer__inner (ao mudar quantidade). innerHTML nao executa <script>, entao
 * um script inline rodaria na primeira carga e nunca mais. Este arquivo carrega
 * uma vez, fora do drawer, e observa o DOM.
 *
 * A CHECAGEM E DE VERDADE
 * Ele le /cart.js e confere `available` da variante de cada item no .js do
 * produto. Os dois segundos sao o tempo MINIMO em que o estado "conferindo"
 * fica na tela, nao uma espera falsa - se a rede demorar mais, ele espera mais;
 * se algo estiver esgotado, a mensagem final e outra.
 */
(function () {
  var MINIMO = 2000;

  function caminhoBase() {
    // /sk-sk, /ro-ro... sem o prefixo o fetch cai em redirect ou 404
    var m = window.location.pathname.match(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i);
    return m && m[0].length <= 6 ? m[0] : '';
  }

  function estado(raiz, qual, texto) {
    raiz.setAttribute('data-estado', qual);
    var t = raiz.querySelector('[data-kc-cartcheck-txt]');
    if (t && texto) t.textContent = texto;
  }

  function confere(raiz) {
    if (raiz.dataset.kcRodou) return;
    raiz.dataset.kcRodou = '1';

    var base = caminhoBase();
    var comecou = Date.now();

    fetch(base + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return { ok: true, vazio: true };
        var handles = {};
        cart.items.forEach(function (i) { (handles[i.handle] = handles[i.handle] || []).push(i.variant_id); });
        return Promise.all(Object.keys(handles).map(function (h) {
          return fetch(base + '/products/' + h + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (p) {
              return handles[h].every(function (id) {
                var v = p.variants.filter(function (x) { return x.id === id; })[0];
                return v ? v.available : true;   // variante sumida: nao acusa
              });
            })
            .catch(function () { return true; }); // rede falhou: nao inventa problema
        })).then(function (r) { return { ok: r.every(Boolean) }; });
      })
      .catch(function () { return { ok: true, falhou: true }; })
      .then(function (r) {
        var falta = Math.max(0, MINIMO - (Date.now() - comecou));
        setTimeout(function () {
          if (r.ok) estado(raiz, 'ok', raiz.dataset.txtOk);
          else estado(raiz, 'esgotado', raiz.dataset.txtEsgotado);
        }, falta);
      });
  }

  // So confere com o drawer aberto. Rodando no load, a checagem terminaria
  // antes de alguem ver, e quem abre o carrinho pelo icone (sem adicionar
  // nada) cairia direto no resultado pronto, sem a engrenagem.
  var talvez = function (drawer) {
    if (!drawer.classList.contains('active')) return;
    [].slice.call(drawer.querySelectorAll('[data-kc-cartcheck]')).forEach(confere);
    relogio();
    social();
  };

  /* --- quantas pessoas estao com o item no carrinho ---
   * Sorteado entre 5 e 12 e ESTAVEL por visitante e por dia: um numero que
   * pula a cada refresh se denuncia sozinho. Nao vem de dado real - a loja nao
   * mede carrinhos simultaneos. */
  function social() {
    var caixas = [].slice.call(document.querySelectorAll('[data-kc-social]'));
    if (!caixas.length) return;
    var MIN = 5, MAX = 12;
    var dia = Math.floor(Date.now() / 86400000);
    var n;
    try {
      var salvo = JSON.parse(localStorage.getItem('kc_pessoas') || 'null');
      if (salvo && salvo.dia === dia) n = salvo.n;
      else { n = MIN + Math.floor(Math.random() * (MAX - MIN + 1));
             localStorage.setItem('kc_pessoas', JSON.stringify({ dia: dia, n: n })); }
    } catch (e) { n = MIN + Math.floor(Math.random() * (MAX - MIN + 1)); }

    caixas.forEach(function (caixa) {
      if (caixa.dataset.kcSocialFeito) return;
      caixa.dataset.kcSocialFeito = '1';
      var t = caixa.querySelector('[data-kc-social-txt]');
      if (t) t.innerHTML = t.innerHTML.replace('{n}', '<b>' + n + '</b>');
      caixa.hidden = false;
    });
  }

  function liga() {
    relogio();   // /cart mostra o relogio sem nenhum drawer abrir
    social();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    talvez(drawer);
    // childList: o tema reescreve o drawer inteiro ao adicionar um item
    // attributes: a classe 'active' entra quando o drawer abre
    new MutationObserver(function () { talvez(drawer); })
      .observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* --- relogio da urgencia no rodape do carrinho ---
   * Mesma chave da barra do topo e da pagina do produto. Se ela nao existir
   * ainda (o visitante caiu direto no carrinho), nasce aqui, com a mesma
   * janela de 24h - e nao reinicia no refresh. */
  function relogio() {
    // a pagina /cart tem o relogio dela E carrega o drawer fechado junto
    [].slice.call(document.querySelectorAll('[data-kc-cart-urgencia]')).forEach(umRelogio);
  }

  function umRelogio(caixa) {
    // Sem esta trava o relogio se multiplica: cada tique escreve no DOM do
    // drawer, o MutationObserver acorda, chama relogio() outra vez e mais um
    // setTimeout entra na fila. Em poucos segundos trava a aba.
    if (caixa.dataset.kcRelogio) return;
    caixa.dataset.kcRelogio = '1';
    var b = caixa.querySelector('[data-kc-cart-relogio]');
    var ate;
    try {
      ate = Number(localStorage.getItem('kc_oferta_ate'));
      if (!ate || isNaN(ate) || ate < Date.now()) {
        ate = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('kc_oferta_ate', String(ate));
      }
    } catch (e) { ate = Date.now() + 24 * 60 * 60 * 1000; }

    function dd(n) { return (n < 10 ? '0' : '') + n; }
    function tique() {
      if (!caixa.isConnected) return;            // drawer reescrito: para o loop
      var t = ate - Date.now();
      if (t <= 0) { caixa.hidden = true; return; }
      var s = Math.floor(t / 1000);
      b.textContent = dd(Math.floor(s / 3600)) + ':' + dd(Math.floor(s / 60) % 60) + ':' + dd(s % 60);
      caixa.hidden = false;
      setTimeout(tique, 1000);
    }
    tique();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga);
  else liga();
})();
